const features = [
  {
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '所有片源均为1080P及以上高清品质，拒绝模糊渣画质。蓝莓影院对每一部上架影片进行画质审核，确保您在大屏幕上也能享受细腻通透的观影效果。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '采用多线CDN加速与智能预加载技术，播放流畅零等待。无论您是追最新热播剧还是重温经典老片，点击即可秒开，告别转圈等待。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日准时更新',
    desc: '编辑团队每日追踪各大平台最新上线内容，第一时间同步更新。热播连载剧集准时追更，精彩电影上线即达，让您永不落伍。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">本站特色</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">为什么千万观众选择蓝莓影院？三大核心优势让您畅享观影乐趣</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${f.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}